import basex from 'base-x'
import { ChatMessage } from '../chat-message/chat-message.fixtures'

export class ChatRoom {
  static fromApiRoom(room: any): ChatRoom {
    const data = ChatRoom.decodeChatRoomData(room?.name ?? '')
    const chatRoom = new ChatRoom(
      room._id,
      data?.name ?? room.name,
      room.t,
      room.ts,
      room.msgs,
      ChatMessage.fromApiMessage(room.lastMessage, undefined),
      room.customFields
    )
    if (room.u?._id) {
      chatRoom.ownerId = room.u?._id
    }
    return chatRoom
  }

  // encode and decode chat room data in its name
  static encodeChatRoomData(data: ChatRoomNameData): string {
    const base58 = basex(ChatRoomEncodingBase)
    const json = JSON.stringify(data)
    const textEncoder = new TextEncoder()
    const textEncoded = textEncoder.encode(json)
    return base58.encode(textEncoded)
  }

  static decodeChatRoomData(encoded: string): ChatRoomNameData {
    try {
      const base58 = basex(ChatRoomEncodingBase)
      const textDecoder = new TextDecoder()
      const textDecoded = base58.decode(encoded)
      const json = textDecoder.decode(textDecoded)
      return JSON.parse(json)
    } catch (error) {
      return undefined
    }
  }

  members: ChatRoomMember[] = []

  ownerId: string | undefined = undefined

  constructor(
    readonly id: string,
    readonly name: string,
    readonly type: string,
    readonly timestamp?: string,
    readonly messageCount?: number,
    readonly lastMessage?: ChatMessage,
    readonly customFields?: {
      [key: string]: string
    }
  ) {}

  getUrl(): string {
    const suffix = '?layout=embedded'
    switch (this.type) {
      case 'c':
        return '/channel/' + this.name + suffix
      case 'p':
        return '/group/' + this.name + suffix
      default:
        return ''
    }
  }

  getJobId(): string {
    return this.customFields
      ? this.customFields[ChatRoomField.jobId]
      : undefined
  }

  isDefined(): boolean {
    return this.type.trim().length > 0
  }

  setMembersFromApi(
    members?: { name: string; username: string; _id: string }[]
  ) {
    this.members =
      members?.flatMap((m) => {
        return { name: m.name, userId: m.username, rocketChatUserId: m._id }
      }) ?? []
  }
}

export type ChatRoomNameData = {
  name: string
  uuid?: string
  userId?: string
}

export type ChatRoomMember = {
  name: string
  userId?: string
  rocketChatUserId?: string
}

export const ChatRoomEncodingBase =
  '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

export enum ChatRoomField {
  jobId = 'jobId',
}

export type GroupedChatRooms = {
  chatRoomsWithActiveJob: ChatRoom[]
  chatRoomsWithInactiveJob: ChatRoom[]
}
